// actions/systems/execute.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function executeHasErrored(bool) {
  return {
    type: 'EXECUTE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function executeIsLoading(bool) {
  return {
    type: 'EXECUTE_IS_LOADING',
    isLoading: bool
  };
}

export function executeFetchDataSuccess(response) {
  return {
    type: 'EXECUTE_FETCH_DATA_SUCCESS',
    response
  };
}

export function executeFetchData(host, body) {
  return (dispatch) => {
    dispatch(executeIsLoading(true));
    dispatch(executeHasErrored(false));
    fetch(host + 'user/execute', {
      method: 'post',
      body: JSON.stringify(body),
      headers: attachAuth()
    }).then(promise => {
      if (!promise.ok) {
        throw Error(promise.statusText);
      }
        
      dispatch(executeIsLoading(false));
      promise.json()
        .then(result => {
          if (result.status === "true") {
            PubSub.publish('pubsub.systems.executed', { id: body.id, process: body.process, success: true });
            dispatch(executeFetchDataSuccess(result))
          }
          else {
            PubSub.publish('pubsub.systems.executed', { id: body.id, process: body.process, success: false });
            dispatch(executeHasErrored(true))  
          }
        })
        .catch((e) => {
          console.log(e);
          PubSub.publish('pubsub.systems.executed', { id: body.id, process: body.process, success: false });
          dispatch(executeHasErrored(true))
        });
      })
      .catch((e) => {
        console.log(e);
        PubSub.publish('pubsub.systems.executed', { process: body.process, success: false });
        dispatch(executeHasErrored(true))
      });
  };
}